var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5832 11.8185C4.84217 12.0694 4.96115 12.4324 4.90216 12.7883L4.01328 17.7077C3.93829 18.1246 4.11427 18.5466 4.46322 18.7875C4.80517 19.0375 5.26011 19.0675 5.63307 18.8675L10.0615 16.5578C10.2155 16.4758 10.3864 16.4319 10.5614 16.4269H10.8324C10.9264 16.4409 11.0184 16.4708 11.1024 16.5168L15.5318 18.8375C15.7507 18.9475 15.9987 18.9865 16.2417 18.9475C16.8336 18.8355 17.2286 18.2716 17.1316 17.6767L16.2417 12.7573C16.1827 12.3984 16.3017 12.0334 16.5606 11.7785L20.1712 8.27892C20.4731 7.98596 20.5781 7.54601 20.4401 7.14907C20.3061 6.75312 19.9642 6.46416 19.5512 6.39916L14.5819 5.67826C14.2039 5.63926 13.872 5.40929 13.702 5.06934L11.5123 0.579924C11.4603 0.479937 11.3933 0.387949 11.3123 0.30996L11.2223 0.239969C11.1753 0.187975 11.1213 0.144981 11.0614 0.109986L10.9524 0.0699909L10.7824 0H10.3614C9.9855 0.0389949 9.65454 0.263966 9.48156 0.599922L7.26285 5.06934C7.10287 5.3963 6.79191 5.62327 6.43296 5.67826L1.46361 6.39916C1.04367 6.45916 0.692713 6.74912 0.55373 7.14907C0.422747 7.55001 0.535732 7.98996 0.843691 8.27892L4.5832 11.8185Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayStar);
export default __webpack_public_path__ + "static/media/GrayStar.b441d5f823ddd7cf9c4ffec3873a405d.svg";
export { ForwardRef as ReactComponent };